import MengniuMonthAudit from './src/main';

/* istanbul ignore next */
MengniuMonthAudit.install = function(Vue) {
  Vue.component(MengniuMonthAudit.name, MengniuMonthAudit);
};

export default MengniuMonthAudit;
